document.addEventListener('DOMContentLoaded', () => {
    
    let themeMode = 'Dark'
    const mainSettings = getCacheItem('mainSettings');
    if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
        themeMode = mainSettings.themeMode;
    } else {
        const parsed = getCacheItem('configureControlSettings');
        if (parsed && (parsed.themeMode === 'Light' || parsed.themeMode === 'Dark')) {
            themeMode = parsed.themeMode;
        }
    }
    applyTheme()
    
    
    const sceneEl = document.querySelector('a-scene');
    if (!sceneEl) return
    if (sceneEl.hasLoaded) {
        sceneEl.addEventListener('theme-changed', (e) =>{
            if (!e || !e.detail) return;
            themeMode = e.detail.themeMode;
            applyTheme()
        });
    } else {
        sceneEl.addEventListener('loaded', () => {
            sceneEl.addEventListener('theme-changed', (e) =>{
                if (!e || !e.detail) return;
                themeMode = e.detail.themeMode;
                applyTheme()
            });
        });
    }
    
    
    function applyTheme() {
        applyForAccountPopUp.bind(this)();
        applyForAuthPopUp.bind(this)();
        applyForResetPassword.bind(this)();
        applyForSetNewPasswordPopUp.bind(this)();
        applyForCompleteAccountPopUp.bind(this)();
        applyForDeleteAccountPopUp.bind(this)();
        applyForInfoPopUp.bind(this)();

        applyToAccountManagementPopUp.bind(this)();
        applyToLinkedDevicesPopUp.bind(this)();
        applyRemoveDevicePopUp.bind(this)();

        function applyForAccountPopUp() {
            const bg = document.querySelector('#account-pop-up .popup-bg');
            const crossIcon =  document.querySelector('#account-pop-up .close-button-text');
            const welcomeText =  document.querySelector('#account-pop-up .welcome-text');
            const usernameText =  document.querySelector('#account-pop-up .current-user-name-text');
            const inputLabel =  document.querySelector('#account-pop-up .input-wrapper a-text');
            const inputBg =  document.querySelector('#account-pop-up .input-wrapper a-rounded-box');
            const input =  document.querySelector('#account-pop-up .input-wrapper input');
            const lines = document.querySelectorAll('#account-pop-up .line');

            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                crossIcon.setAttribute('color', '#fff')
                welcomeText.setAttribute('color', '#fff')
                usernameText.setAttribute('color', '#fff')
                inputLabel.setAttribute('color', '#fff')
                inputBg.setAttribute('material', 'shader: flat; color: #202028')
                input.setAttribute('color', '#fff')
                input.style.color = '#fff'
                lines.forEach(line => line.setAttribute('material', "shader: flat; color: #202028"))
            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff');
                crossIcon.setAttribute('color', '#111')
                welcomeText.setAttribute('color', '#111')
                usernameText.setAttribute('color', '#111')
                inputLabel.setAttribute('color', '#111')
                inputBg.setAttribute('material', 'shader: flat; color: #F4F4F4')
                input.style.color = '#111'
                lines.forEach(line => line.setAttribute('material', "shader: flat; color: #dddddd"))
            }
        }
        function applyForAuthPopUp() {
            const authBgBig = document.querySelector('#authorization-pop-up .popup-bg-big');
            const authBgSmall = document.querySelector('#authorization-pop-up .popup-bg-small');
            const authCrossIcon =  document.querySelector('#authorization-pop-up .close-button-wrapper a-text');
            const authHeader = document.querySelector('#authorization-pop-up .auth-title');

            const allInputBgs = document.querySelectorAll('#authorization-pop-up .input-wrapper a-rounded-box');
            const allInputLabels = document.querySelectorAll('#authorization-pop-up .input-wrapper a-text');
            const allInputs = document.querySelectorAll('#authorization-pop-up .input-wrapper input');
            const allLines = document.querySelectorAll('#authorization-pop-up .line');

            const codeBg = document.querySelector('#authorization-pop-up .right-content a-rounded-box');
            const codeText = document.querySelector('#authorization-pop-up .right-content #link-code');

            const tipText = document.querySelector('#authorization-pop-up .tip-text');

            if (themeMode === 'Dark') {
                authBgBig.setAttribute('material', 'shader: flat; color: #14141C');
                authBgSmall.setAttribute('material', 'shader: flat; color: #14141C');
                authCrossIcon.setAttribute('color', '#fff')
                authHeader.setAttribute('color', '#fff')

                allInputBgs.forEach(bg => bg.setAttribute('material', 'shader: flat; color: #202028'))
                allInputLabels.forEach(label => label.setAttribute('color', '#fff'))
                allInputs.forEach(input => input.style.color = '#fff')
                allLines.forEach(line => line.setAttribute('material', "shader: flat; color: #202028"))

                codeBg.setAttribute('material', 'shader: flat; color: #202028');
                codeText.setAttribute('color', '#fff');

                tipText.setAttribute('color', '#fff');
            } else {
                authBgBig.setAttribute('material', 'shader: flat; color: #fff');
                authBgSmall.setAttribute('material', 'shader: flat; color: #fff');
                authCrossIcon.setAttribute('color', '#111')
                authHeader.setAttribute('color', '#111')

                allInputBgs.forEach(bg => bg.setAttribute('material', 'shader: flat; color: #F4F4F4'))
                allInputLabels.forEach(label => label.setAttribute('color', '#111'))
                allInputs.forEach(input => input.style.color = '#111')
                allLines.forEach(line => line.setAttribute('material', "shader: flat; color: #dddddd"))

                codeBg.setAttribute('material', 'shader: flat; color: #F4F4F4');
                codeText.setAttribute('color', '#111');

                tipText.setAttribute('color', '#111');
            }
        }
        function applyForResetPassword() {
            const bg =  document.querySelector('#reset-password-pop-up .popup-bg');
            const crossIcon =  document.querySelector('#reset-password-pop-up .close-button-text');
            const header =  document.querySelector('#reset-password-pop-up .header');
            const description =  document.querySelector('#reset-password-pop-up .description');
            const inputLabel =  document.querySelector('#reset-password-pop-up .input-wrapper a-text');
            const inputBg =  document.querySelector('#reset-password-pop-up .input-wrapper a-rounded-box');
            const input =  document.querySelector('#reset-password-pop-up .input-wrapper input');

            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                crossIcon.setAttribute('color', '#fff')
                header.setAttribute('color', '#fff')
                description.setAttribute('color', '#fff')
                inputLabel.setAttribute('color', '#fff')
                inputBg.setAttribute('material', 'shader: flat; color: #202028')
                input.setAttribute('color', '#fff')
                input.style.color = '#fff'
            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff');
                crossIcon.setAttribute('color', '#111')
                header.setAttribute('color', '#111')
                description.setAttribute('color', '#111')
                inputLabel.setAttribute('color', '#111')
                inputBg.setAttribute('material', 'shader: flat; color: #F4F4F4')
                input.style.color = '#111'
            }
        }
        function applyForSetNewPasswordPopUp() {
            const bg =  document.querySelector('#account-set-new-password .popup-bg');
            const crossIcon =  document.querySelector('#account-set-new-password .close-button-text');
            const header =  document.querySelector('#account-set-new-password  .header');

            const allInputBgs = document.querySelectorAll('#account-set-new-password .input-wrapper a-rounded-box');
            const allInputLabels = document.querySelectorAll('#account-set-new-password  .input-wrapper a-text');
            const allInputs = document.querySelectorAll('#account-set-new-password  .input-wrapper input');

            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                crossIcon.setAttribute('color', '#fff')
                header.setAttribute('color', '#fff')

                allInputBgs.forEach(bg => bg.setAttribute('material', 'shader: flat; color: #202028'))
                allInputLabels.forEach(label => label.setAttribute('color', '#fff'))
                allInputs.forEach(input => input.style.color = '#fff')

            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff');
                crossIcon.setAttribute('color', '#111')
                header.setAttribute('color', '#111')

                allInputBgs.forEach(bg => bg.setAttribute('material', 'shader: flat; color: #F4F4F4'))
                allInputLabels.forEach(label => label.setAttribute('color', '#111'))
                allInputs.forEach(input => input.style.color = '#111')

            }
        }
        function applyForCompleteAccountPopUp() {
            const bg =  document.querySelector('#complete-account-pop-up .popup-bg');
            const crossIcon =  document.querySelector('#complete-account-pop-up .close-button-text');
            const header =  document.querySelector('#complete-account-pop-up  .header');
            const description =  document.querySelector('#complete-account-pop-up  .description');

            const allInputBgs = document.querySelectorAll('#complete-account-pop-up .input-wrapper a-rounded-box');
            const allInputLabels = document.querySelectorAll('#complete-account-pop-up  .input-wrapper a-text');
            const allInputs = document.querySelectorAll('#complete-account-pop-up  .input-wrapper input');

            const line = document.querySelector('#complete-account-pop-up .line');

            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                crossIcon.setAttribute('color', '#fff')
                header.setAttribute('color', '#fff')
                description.setAttribute('color', '#fff')

                allInputBgs.forEach(bg => bg.setAttribute('material', 'shader: flat; color: #202028'))
                allInputLabels.forEach(label => label.setAttribute('color', '#fff'))
                allInputs.forEach(input => input.style.color = '#fff')

                line.setAttribute('material', "shader: flat; color: #202028")
            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff');
                crossIcon.setAttribute('color', '#111')
                header.setAttribute('color', '#111')
                description.setAttribute('color', '#111')

                allInputBgs.forEach(bg => bg.setAttribute('material', 'shader: flat; color: #F4F4F4'))
                allInputLabels.forEach(label => label.setAttribute('color', '#111'))
                allInputs.forEach(input => input.style.color = '#111')

                line.setAttribute('material', "shader: flat; color: #dddddd")
            }
        }
        function applyForDeleteAccountPopUp() {
            const bg =  document.querySelector('#delete-account-pop-up a-rounded-box');
            const text =  document.querySelector('#delete-account-pop-up a-text');

            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                text.setAttribute('color', '#fff')
            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff')
                text.setAttribute('color', '#111')
            }
        }
        function applyForInfoPopUp() {
            const bg =  document.querySelector('#account-info-message-pop-up a-rounded-box');
            const text =  document.querySelector('#account-info-message-pop-up a-text');
            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                text.setAttribute('color', '#fff')
            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff')
                text.setAttribute('color', '#111')
            }
        }
        
        function applyToAccountManagementPopUp() {
            const bg =  document.querySelector('#account-management-pop-up .popup-bg');
            const backImg = document.querySelector('#account-management-pop-up .back-img');
            const crossIcon =  document.querySelector('#account-management-pop-up .close-button-text');
            const header =  document.querySelector('#account-management-pop-up .header');
            const subHeaders =  document.querySelectorAll('#account-management-pop-up .sub-header');
            
            const inputBg = document.querySelector('#account-management-pop-up .input-wrapper a-rounded-box');
            const input = document.querySelector('#account-management-pop-up .input-wrapper input');
            
            const subscriptionBg = document.querySelector('#account-management-pop-up .subscription-section .field-wrapper a-rounded-box');
            const subscriptionText = document.querySelector('#account-management-pop-up .subscription-section .field-wrapper a-text');
            
            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                backImg.setAttribute('color', '#fff')
                crossIcon.setAttribute('color', '#fff')
                header.setAttribute('color', '#fff')
                subHeaders.forEach(subHeader => subHeader.setAttribute('color', '#fff'))

                inputBg.setAttribute('material', 'shader: flat; color: #202028')
                input.style.color = '#fff'

                subscriptionBg.setAttribute('material', 'shader: flat; color: #202028')
                subscriptionText.setAttribute('color', '#fff')
            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff')
                backImg.setAttribute('color', '#111')
                crossIcon.setAttribute('color', '#111')
                header.setAttribute('color', '#111')
                subHeaders.forEach(subHeader => subHeader.setAttribute('color', '#111'))

                inputBg.setAttribute('material', 'shader: flat; color: #F4F4F4')
                input.style.color = '#111'

                subscriptionBg.setAttribute('material', 'shader: flat; color: #F4F4F4')
                subscriptionText.setAttribute('color', '#111')
            }
        }
        function applyToLinkedDevicesPopUp() {
            const bg =  document.querySelector('#linked-devices-pop-up .popup-bg');
            const backImg = document.querySelector('#linked-devices-pop-up .back-img');
            const crossIcon =  document.querySelector('#linked-devices-pop-up .close-button-text');
            const header =  document.querySelector('#linked-devices-pop-up .header');

            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                bg.setAttribute('color', '#14141C');
                backImg.setAttribute('color', '#fff')
                crossIcon.setAttribute('color', '#fff')
                header.setAttribute('color', '#fff')
                
            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff')
                bg.setAttribute('color', '#fff');
                backImg.setAttribute('color', '#111')
                crossIcon.setAttribute('color', '#111')
                header.setAttribute('color', '#111')
               
            }
        }
        function applyRemoveDevicePopUp() {
            const bg =  document.querySelector('#remove-device-pop-up a-rounded-box');
            const text =  document.querySelector('#remove-device-pop-up a-text');

            if (themeMode === 'Dark') {
                bg.setAttribute('material', 'shader: flat; color: #14141C');
                text.setAttribute('color', '#fff')
            } else {
                bg.setAttribute('material', 'shader: flat; color: #fff')
                text.setAttribute('color', '#111')
            }
        }
    }
})